module.exports = __webpack_public_path__ + "static/media/facebook.e05029bb.svg";